import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { getConfigObject, useBaseData } from "../utils/utils";
import { UserControllerApi } from "../services";

interface UseUsersListProps {
  providerGroupId?: string;
  disabled?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useUserProfile({
  providerGroupId,
  disabled,
}: UseUsersListProps): useBaseData<any> {
  return useQuery({
    queryKey: ["user-profile", providerGroupId],
    placeholderData: keepPreviousData,
    enabled:
      (providerGroupId !== undefined || providerGroupId !== null) && !disabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new UserControllerApi(getConfigObject())
        .getProfile1(
          providerGroupId ?? providerGroupId //xTENANTID
        )
        .then((it) => it?.data),
  });
}
